import {gsap} from 'gsap';
import {ScrollToPlugin} from 'gsap/ScrollToPlugin';

export default class TourismMeansMoreHero {

  constructor(tmmHero) {
    gsap.registerPlugin(ScrollToPlugin);

    this.root = tmmHero;
    this.cardsOutterContentContainers = this.root.querySelectorAll('.js-tmm-single-card');
    this.showMoreContainer = this.root.querySelector('.js-tmm-card-container');
    this.showMoreButton = this.root.querySelector('.js-show-more-button');
    this.fullLogo = this.root.querySelector('.js-tmm-full-logo');

    if (this.showMoreContainer && this.showMoreButton) {
      this.init();
    }
  }

  init() {
    if (this.showMoreButton) {
      this.showMoreButton.addEventListener('click', (e) => {
        this.showMore(e);
      });
    }

    if (this.cardsOutterContentContainers.length > 0 && this.root.classList.contains('--v2-styles')) {
      this.animateCardsOnLoad()
    }
  }

  removeClassRandomly(elements, className) {
    const shuffledElements = gsap.utils.shuffle(Array.from(elements));

    shuffledElements.forEach((element, index) => {
      gsap.delayedCall(index * 0.2, () => {
        element.classList.remove(className);
      });
    });
  }

  hideElement(element) {
    element.style.display = 'none';
  }

  animateCardsOnLoad() {
    const matchMedia = gsap.matchMedia();


    matchMedia.add("(prefers-reduced-motion: no-preference)", (context) => {

      const cardsTl = gsap.timeline()

      if (this.fullLogo) {
        cardsTl.to('.tourism-means-more-hero__full-logo img', {
          opacity: 1,
          scale: 1,
          duration: 1,
          ease: 'power2.inOut'
        })

        cardsTl.to('.tourism-means-more-hero__full-logo img', {
          opacity: 0,
          scale: 2.5,
          duration: 1,
          ease: 'power2.inOut',
        }, '+=1')

        cardsTl.to('.tourism-means-more-hero__full-logo', {
          opacity: 0,
          duration: 1,
          ease: "power2.inOut"
        }, '-=1')
      }

      cardsTl.add(() => this.removeClassRandomly(this.cardsOutterContentContainers, 'show-card'))

      if (this.fullLogo) {
        cardsTl.add(() => this.hideElement(this.fullLogo));
      }
    });

    matchMedia.add("(prefers-reduced-motion: reduce)", (context) => {
      this.cardsOutterContentContainers.forEach((element, index) => {
        element.classList.remove('show-card');
      })
    });

  }

  showMore(e) {
    e.preventDefault();
    if (this.root.classList.contains('--show-more')) {

      this.root.classList.remove('--show-more');
      this.root.classList.add('--show-less');

      gsap.to(this.showMoreContainer, {height: 'auto', duration: 0.5});

      this.showMoreButton.classList.add('--up-arrow');
      this.showMoreButton.classList.remove('--down-arrow');

    } else {

      this.root.classList.add('--show-more');
      this.root.classList.remove('--show-less');

      gsap.to(this.showMoreContainer, {
        height: '800px',
        duration: 0.5,
      });

      gsap.to(window, {duration: .5, scrollTo: {y: this.root, offsetY: 145}});

      this.showMoreButton.classList.add('--down-arrow');
      this.showMoreButton.classList.remove('--up-arrow');
    }
  }
}
